// Public project token, meant for browser code. EU region keeps data in Frankfurt.
export const POSTHOG_PROJECT_TOKEN =
  "phc_qCA86BiXrbCTpQK4qhfkckFVWmzSVdtTUuaouCFptTit";
export const POSTHOG_HOST = "https://eu.i.posthog.com";

/** Production only, so preview and local noise stays out. Local opt-in for testing. */
export function isErrorTrackingEnabled(): boolean {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV === "production") return true;
  return process.env.NEXT_PUBLIC_ERROR_TRACKING === "true";
}

export function errorTrackingEnvironment(): string {
  return process.env.NEXT_PUBLIC_VERCEL_ENV || "local";
}

/** `userError` rejections are intended user hints, not bugs. */
export function isIntentionalUserError(error: unknown): boolean {
  return error instanceof Error && error.name === "ConvexError";
}
